module.exports = __webpack_public_path__ + "img/slider.e34837d.jpg";